"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveConsent = resolveConsent;
exports.consentFromEnv = consentFromEnv;
/**
 * The opt-in gate. Telemetry is enabled only when the host explicitly opted in
 * AND a capture key is present — either condition missing means a Noop client.
 * This is the single place the "opt-in only" policy is enforced.
 */
function resolveConsent(config) {
    return config.enabled === true && !!config.apiKey;
}
/**
 * Interpret the `LOOM_TELEMETRY` env var (the CLI / agent opt-in switch). Opt-in
 * semantics: only an explicit truthy value enables it; absence or anything else
 * means disabled. Never treat "unset" as consent.
 */
function consentFromEnv(env = process.env) {
    const v = (env.LOOM_TELEMETRY ?? '').trim().toLowerCase();
    return v === '1' || v === 'true' || v === 'on' || v === 'yes';
}
